import type {
  GridFilterModel,
  GridPaginationModel,
  GridRowId,
  GridRowSelectionModel,
} from '@mui/x-data-grid-pro';

export type RowId = GridRowId;
export type RowIds = Set<GridRowId>;

/**
 * Enables row selection:
 * - 'off': not enabled, default
 * - 'single': single row selection enabled, with radio buttons to indicate current selection
 * - 'multiple': multiple rows selection enabled, with check boxes to indicate selected rows
 */
export type RowSelectionMode = 'single' | 'multiple';
export type RowSelectionModel = GridRowSelectionModel;

export type FilterModel = Pick<GridFilterModel, 'items' | 'logicOperator'>;
export type PaginationModel = GridPaginationModel;

export type QuickFilter = {
  title: string;
  filterModel: FilterModel;
};

export const DEFAULT_PAGINATION_MODEL: PaginationModel = {
  page: 0,
  pageSize: 20,
};
